<div *transloco="let t; read: 'mailMessage'" class="root">
  <div (click)="toggleMessage()" class="head" [class.-expandable]="!alwaysExpanded">
    <crm-grid [class.-unread]="!threadMessage.isRead" class="head-top">
      <crm-grid-col [cols]="9">
        <span class="user-info">
          <crm-user-info
            [user]="(threadMessage | mailParticipantFrom).person?.general"
            [ifEmpty]="(threadMessage | mailParticipantFrom).email"
          ></crm-user-info>
        </span>
        <span class="to">
          <span class="to-title">{{ t('toWhom') }}</span>
          <span class="user-info">
            <crm-user-info [user]="threadMessage.to.person?.general" [ifEmpty]="threadMessage.to.email"></crm-user-info>
          </span>
        </span>
      </crm-grid-col>
      <crm-grid-col [cols]="1">
        <mat-icon *ngIf="threadMessage.hasAttachments">attachment</mat-icon>
      </crm-grid-col>
      <crm-grid-col [cols]="2" class="crm-text-right">{{ threadMessage.receivedAt | date : 'short' }}</crm-grid-col>
    </crm-grid>
    <div *ngIf="!isMessageExpanded" class="content">
      <span class="snippet">{{ threadMessage.snippet }}</span>
    </div>
  </div>

  <div *ngIf="isMessageExpanded" class="body">
    <ng-container *ngIf="mailMessage$ | async as mailMessage; else messageLoading">
      <iframe [srcdoc]="mailMessage.body | safeIframeHtml" class="body-content" width="100%"></iframe>

      <div *ngIf="mailMessage.attachments?.length > 0" class="attachments">
        <a
          *ngFor="let attachment of mailMessage.attachments"
          mat-stroked-button
          class="attachment"
          [href]="baseEndpoint + 'emails/attachments/' + attachment.id + '/'"
          target="_blank"
        >
          <mat-icon>{{ attachment.mimeType | fileIcon }}</mat-icon>
          {{ attachment.name }}
        </a>
      </div>

      <crm-actions-row *ngIf="!isReplyExpanded">
        <button
          *ngIf="mailMessage.inbox === true"
          (click)="toggleReply()"
          type="button"
          color="primary"
          mat-flat-button
        >
          {{ t('reply') }}
        </button>
        <button *ngIf="!mailMessage.isRead" (click)="markAsRead()" type="button" mat-flat-button>
          {{ t('markAsRead') }}
        </button>
      </crm-actions-row>

      <crm-mail-reply
        *ngIf="isReplyExpanded"
        [messageToReply]="mailMessage"
        (cancel)="toggleReply()"
        (sent)="toggleReply()"
      ></crm-mail-reply>
    </ng-container>

    <ng-template #messageLoading>
      <mat-spinner [diameter]="20"></mat-spinner>
    </ng-template>
  </div>
</div>
